module.exports = __webpack_public_path__ + "static/img/fingerpost_buy_1.06b6a98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_buy_1.jpg
// module id = Juke
// module chunks = 0